import { Phone, MapPin, Mail, Clock, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { CLINIC, NAV, IMAGES } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-[#2A2521] text-white/70 pt-16 pb-28 lg:pb-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3">
              <span className="brand-serif text-3xl gold-text-gradient pr-[0.35em]">MEDAS</span>
              <span className="brand-serif text-base italic text-[#DCC79A]">by Excellab</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed">
              Rețea medicală și laborator de analize din 2007. Îngrijire rafinată, rezultate în care ai încredere.
            </p>
            <a href={CLINIC.resultsUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-results-button"
              className="mt-5 inline-flex items-center gap-2 bg-[#A6823B] hover:bg-[#8A6B2E] text-white font-semibold px-5 py-2.5 rounded-full transition-colors text-sm">
              <Download className="w-4 h-4" /> Rezultate online
            </a>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4">Navigare</h4>
            <ul className="space-y-2.5 text-sm">
              {NAV.map((n) => (
                <li key={n.to}><Link to={n.to} className="hover:text-[#DCC79A] transition-colors">{n.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#DCC79A]" /> {CLINIC.address}</li>
              <li><a href={CLINIC.phoneRaw} className="flex items-center gap-2 hover:text-[#DCC79A]"><Phone className="w-4 h-4 text-[#DCC79A]" /> {CLINIC.phone}</a></li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#DCC79A]" /> {CLINIC.email}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4">Program</h4>
            <ul className="space-y-2 text-sm">
              {CLINIC.schedule.map((s) => (
                <li key={s.day} className="flex items-start gap-2"><Clock className="w-4 h-4 mt-0.5 text-[#DCC79A]" /> {s.day}: {s.hours}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs">
          <p>© {new Date().getFullYear()} MEDAS. Toate drepturile rezervate.</p>
          <div className="flex gap-5">
            <Link to="/politica-confidentialitate" className="hover:text-white">Politica de confidențialitate</Link>
            <Link to="/politica-cookieuri" className="hover:text-white">Politica de cookie-uri</Link>
            <Link to="/termeni-conditii" className="hover:text-white">Termeni și condiții</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
